import React from 'react';
import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import GeneralPopover from 'components/GeneralPopover';

/**
 * Separa los campos de un formulario
 * ----------Texto------------
 */
const DividerForm = ({
  text,
  style,
  variant,
  titleHelpMessage,
}) => {
  const isSmallView = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  return (
    <>
      {isSmallView && (
        <Grid container direction="row" style={style}>
          <Grid item xs={12} md={12} xl={12}>
            <Divider style={{ height: 3, marginTop: 5 }} />
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}
          >
            <Typography variant={variant} align="center" style={{ marginTop: 3 }}>
              {text}
            </Typography>
            {titleHelpMessage && (
              <GeneralPopover message={titleHelpMessage} />
            )}
          </Grid>
        </Grid>
      )}
      {!isSmallView && (
        <Grid container direction="row" style={style}>
          <Grid item xs={2} md={5} xl={5}>
            <Divider style={{ height: 3, marginTop: 5 }} />
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            xl={2}
            style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}
          >
            <>
              <Typography variant={variant} align="center" style={{ marginTop: 3 }}>
                {text}
              </Typography>
              {titleHelpMessage && (
                <GeneralPopover message={titleHelpMessage} />
              )}
            </>
          </Grid>
          <Grid item xs={2} md={5} xl={5}>
            <Divider style={{ height: 3, marginTop: 5 }} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

DividerForm.propTypes = {
  // Texto que se muestra en el formulario
  text: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  style: PropTypes.shape(),
  // Mensaje de recomendaciones
  titleHelpMessage: PropTypes.string,
};

export default DividerForm;
